<template>
  <div class="w-full">
    <div class="supply rounded px-2 pt-2 pb-8 mb-6">
      <el-row :gutter="20">
        <el-col :span="24" class="mb-6">
          <el-button icon="el-icon-back" size="small"
                     @click="$router.push('/ecommerce/supply/goods')">Back to list</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" class="float-right"
                     @click="onDeleteSupply(supply.id)">Delete</el-button>
          <el-button type="warning" icon="el-icon-edit" size="small" class="float-right"
                     @click="onEditSupply(supply.id)">Edit</el-button>
          <el-button class="float-right" type="primary" icon="el-icon-plus" size="small"
                     @click="$router.push('/ecommerce/supply/goods/new')">New</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"><div class="px-4 mb-6 hd">Code:</div></el-col>
        <el-col :span="18">
          <div class="px-4 mb-6">{{ supply.code }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20"  v-if="supply.outlet">
        <el-col :span="6"><div class="px-4 mb-6 hd">Outlet:</div></el-col>
        <el-col :span="18"><div class="px-4 mb-6">{{ supply.outlet.name }}</div></el-col>
      </el-row>
      <el-row :gutter="20"  v-if="supply.supplier">
        <el-col :span="6"><div class="px-4 mb-6 hd">Supplier:</div></el-col>
        <el-col :span="18"><div class="px-4 mb-6">{{ supply.supplier.name }}</div></el-col>
      </el-row>
      <el-row class="px-5">
        <el-col :span="24">
          <template v-if="supply.goods && supply.goods.length > 0">
            <el-table :data="supply.goods" style="width: 100%">
              <el-table-column
                label="Goods">
                <template slot-scope="scope">{{scope.row.name}}</template>
              </el-table-column>
              <el-table-column
                label="Quantity">
                <template slot-scope="scope">{{scope.row.quantity}}</template>
              </el-table-column>
              <el-table-column>
                <template slot="header" slot-scope="scope">
                  <el-button type="info" plain size="small" icon="el-icon-plus"
                             @click="$modal.show('new-supplied-good-modal')">Add Goods</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button @click="openEditDialog(scope.row)" type="text" size="small">
                    <i class="text-xl el-icon-edit-outline mr-4"></i>
                  </el-button>
                  <el-button @click="deleteSuppliedGood(scope.row.id)" type="text" size="small">
                    <i class="text-xl text-red-500 el-icon-delete-solid"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table><br>
          </template>
        </el-col>
      </el-row>
    </div>
    <NewSuppliedGoodForm />
    <UpdateSuppliedGoodForm />
  </div>
</template>

<script>
import NewSuppliedGoodForm from './_includes/NewSuppliedGoodForm.vue';
import UpdateSuppliedGoodForm from './_includes/UpdateSuppliedGoodForm.vue';

export default {
  name: 'SupplyDetails',
  components: {
    NewSuppliedGoodForm,
    UpdateSuppliedGoodForm,
  },
  computed: {
    supply() {
      return this.$store.state.InventoryModule.Supplies.supply;
    },
  },
  methods: {
    onEditSupply(id) {
      this.$router.push(`/ecommerce/supply/goods/${id}/edit`);
    },
    onDeleteSupply(supplyId) {
      this.$confirm('Are you sure you want to delete this supply?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Supplies/deleteSupply', { supplyId });
          this.$notify.success({
            title: 'Success',
            message: 'Supply has been deleted.',
          });
          await this.$router.push('/ecommerce/supply/goods');
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    openEditDialog(suppliedGood) {
      this.$store.commit('InventoryModule/Supplies/setSuppliedGood', { property: 'supplied_good', payload: suppliedGood });
      this.$modal.show('update-supplied-good-modal');
    },
    async deleteSuppliedGood(suppliedGoodId) {
      this.$confirm('Are you sure you want to delete this supplied good?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Supplies/deleteSuppliedGood', { suppliedGoodId });
          this.$notify.success({
            title: 'Success',
            message: 'Supply good has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('InventoryModule/Supplies/getSupply', this.$route.params.id);
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped>
  .supply {
    font-size: 15px;
  }
  .hd {font-weight: 500;}
</style>
